<template>
  <div class="creditList">
    <!-- 添加按钮 -->
    <div class="addCredit" @click="toAddCAredit">
      <van-icon name="plus" size="0.36rem" />
    </div>

    <!-- 搜索 -->
    <div class="search_bar">
      <van-search
        v-model="listQuery.buyer_name"
        show-action
        placeholder="请输入买家姓名进行搜索"
        @search="onSearch"
      >
        <template slot="action">
          <div @click="onSearch"> 搜 索 </div>
        </template>
      </van-search>
    </div>
    <!-- 欠款统计 -->
    <div >

    </div>
    <!-- 列表 -->
    <div class="list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:100%">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getList"
            >
            <div class="item item_top">
              <div>
                <span>{{debts_total}}</span>
                <span>总欠款额(元)</span>
              </div>
              <div>
                <span>{{buyer_total}}</span>
                <span>欠款人数</span>
              </div>
              <div>
                <span>{{buyer_record_total}}</span>
                <span>欠款笔数</span>
              </div>
            </div>
            <div class="item" v-for="(item,index) in list" :key="index" @click="toBuyerDetail(item)">
                <div class="item_1" style="width:60%">
                    <div class="item_title van-ellipsis">
                        {{item.buyer_name}}
                    </div>
                    <div class="item_date">
                        最长赊欠时间：{{item.credit_time_max}}天
                    </div>
                </div>
                <div class="item_2">
                  <span>欠款：</span><span style="color:#EF9B2F">{{item.debts}}元</span>
                </div>
            </div>
            <div style="height:0.5rem"></div>
            </van-list>
        </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {credit_list} from "@/api/work/credit/credit"
export default {
  name: 'creditList',
  data(){
    return {
      list: [],
      loading: true,
      finished: true,
      refreshing: false,
      listQuery:{
          page:1,
          pageSize:'15',  
          buyer_name:''
      },
      buyer_record_total:'0',
      buyer_total:'0',
      debts_total:'0',
    }
  },
  created(){
    this.getList()
    
    this.$navigation.on('back', (to, from) => {
      if(from.route.name == 'credit_creditList' || from.route.name == 'credit_addCredit' || from.route.name == 'manage_buyer_buyerDetail'){
        this.getList()
      }
    })
  },
  mounted(){

  },
  methods:{
    // 点击了搜索按钮
    onSearch(){
      this.getList()
    },

    
    // 获取列表
    getList(){
      // this.finished = false
      credit_list(this.listQuery).then(res=>{
        if(res.code == 200 ){
            this.list = res.data.buyer
            this.buyer_record_total = res.data.buyer_record_total
            this.buyer_total = res.data.buyer_total
            this.debts_total = res.data.debts_total
            this.finished = true;
            this.loading = false
            this.refreshing = false;
        }
      })
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1
      this.getList();
    },

    
    // 去订单补录
    toAddCAredit() {
      this.$router.push({
        path: "/credit/addCredit"
      });
    },

    // 去买家详情
    toBuyerDetail(item){
      this.$router.push({
        path: "/manage/buyer/buyerDetail",
        query:{
          id:item.buyer_id
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.creditList{
  position: relative;
  .addCredit{
    position: fixed;
    top: 0;
    width: 0.88rem;
    height: 0.88rem;
    right: 0.1rem;
    z-index: 99;
    font-size: 0.32rem;
    color: #31B158;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .search_bar{
    position: sticky;
    top: 0.88rem;
    z-index: 2;
    box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }
  .list{
    position: relative;
    .item{
      margin: 0.2rem 0.3rem 0;
      border-radius: 0.1rem;
      background-color: #fff;
      height: 1.3rem;
      box-sizing: border-box;
      padding:0 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.28rem;
      .item_1{
        .item_title{
          font-size: 0.34rem;
          font-weight: 500;
        }
        .item_date{
          color: #999999;
          margin-top: 0.05rem;
        }
      }
    }
    .item_top{
      &>div{
        width: 33%;
        span{
          display: block;
          text-align: center;
          font-size: 0.28rem;
          color: #999;
        }
        &>span:nth-child(1){
          color: #EF9B2F;
          font-size: 0.36rem;
          margin-bottom: 0.06rem;
        }
      }
    }
  }
}
</style>